import { Button, SyncIcon } from '@fluentui/react-northstar';
import { UseInfiniteSource } from 'components/Table/Source';
import { useCallback } from 'react';

export function RefreshListAction({ source, title }: { source: UseInfiniteSource; title: string }) {

	const { refetch } = source;

	const onClick = useCallback(() => refetch(), [refetch]);

	return (
		<Button
			icon={<SyncIcon />}
			text
			iconOnly
			onClick={onClick}
			title={title}
		/>
	);
}
